export default __webpack_public_path__ + "static/media/learn-program.3b6395c0.jpg";